import React from 'react'
import styles from './DropdownMenu.module.scss'

interface DropdownMenuProps {
  open: boolean
  children: React.ReactNode
  className?: never
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ open, children }) => {
  if (!open) return null

  return <div className={styles.menu}>{children}</div>
}
